import { EdgeUI, NodeUI } from './types'
import { nodeIsValid } from './utils'

// Utility function to update nodes with validation and step calculation
export const updateNodesWithValidationAndSteps = (nodes: NodeUI[], edges: EdgeUI[]): NodeUI[] => {
  const stepByNodeId = new Map<string, number>()
  const triggerNodes = nodes.filter((node) => node.type === 'trigger')

  // Initialize trigger nodes with step 1
  triggerNodes.forEach((trigger) => {
    stepByNodeId.set(trigger.id, 1)
  })

  // Calculate steps using BFS from trigger nodes
  const queue: { nodeId: string; step: number }[] = triggerNodes.map((trigger) => ({
    nodeId: trigger.id,
    step: 1,
  }))
  const visited = new Set<string>(triggerNodes.map((t) => t.id))

  while (queue.length > 0) {
    const node = queue.shift()
    if (!node) continue
    const { nodeId, step } = node

    const outgoingEdges = edges.filter((edge) => edge.source === nodeId)

    outgoingEdges.forEach((edge) => {
      const targetNode = nodes.find((n) => n.id === edge.target)
      if (!targetNode) return

      const shouldIncrementStep =
        targetNode.type !== 'conditionIf' && targetNode.type !== 'conditionElse'
      const newStep = shouldIncrementStep ? step + 1 : step

      const isUnvisited = !visited.has(edge.target)
      const currentStep = stepByNodeId.get(edge.target) ?? Infinity
      const hasLowerStep = currentStep > newStep

      if (isUnvisited || hasLowerStep) {
        stepByNodeId.set(edge.target, newStep)
        visited.add(edge.target)
        queue.push({ nodeId: edge.target, step: newStep })
      }
    })
  }

  // Update nodes with validation and step information
  return nodes.map((node) => {
    const updatedNode = { ...node }
    updatedNode.data = {
      ...node.data,
      isValid: nodeIsValid(node, edges),
      step: stepByNodeId.get(node.id) ?? 1,
    }
    return updatedNode
  })
}
